import { DOMAIN } from '../constants';

export function getDomainBySource(source: string) {
  return `${DOMAIN}.${source}`;
}
